import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, API } from '../App';
import Navbar from '../components/Navbar';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { toast } from 'sonner';
import { format } from 'date-fns';
import { parseLocalDate } from '../utils/dateTime';

const MySignups = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSignups();
  }, []);

  const fetchSignups = async () => {
    try {
      const response = await axios.get(`${API}/signups/my`);
      setSignups(response.data);
    } catch (error) {
      toast.error('Failed to load signups');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="flex items-center justify-center py-20">
          <div className="text-lg">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="my-signups-page">
      <Navbar />
      
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#222222] mb-3">My Sign-ups</h1>
          <p className="text-base text-[#666666]">
            View all your upcoming volunteer commitments.
          </p>
        </div>

        {signups.length === 0 ? (
          <div className="card text-center py-12" data-testid="no-signups-message">
            <p className="text-[#666666] mb-4">You haven't signed up for any opportunities yet.</p>
            <button
              onClick={() => navigate('/')}
              className="btn-primary"
              data-testid="browse-opportunities-button"
            >
              Browse Opportunities
            </button>
          </div>
        ) : (
          <div className="grid gap-4">
            {signups.map((signup) => {
              const oppDate = parseLocalDate(signup.opportunity_date);
              const formattedDate = format(oppDate, 'MMM d, yyyy');
              
              return (
                <div
                  key={signup.id}
                  className="card hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => navigate(`/opportunity/${signup.opportunity_id}`)}
                  data-testid={`signup-card-${signup.id}`}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-[#222222] mb-2">
                        {signup.opportunity_title}
                      </h3>
                      <div className="flex flex-wrap gap-4 text-sm text-[#666666]">
                        <div className="flex items-center gap-2">
                          <Calendar className="w-4 h-4" />
                          {formattedDate}
                        </div>
                        <div className="flex items-center gap-2">
                          {signup.status === 'pending' && (
                            <span className="badge badge-pending">Pending Approval</span>
                          )}
                          {signup.status === 'approved' && (
                            <span className="badge badge-approved">Approved</span>
                          )}
                          {signup.status === 'declined' && (
                            <span className="badge" style={{backgroundColor: '#FEE2E2', color: '#991B1B'}}>Declined</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn-outline"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/opportunity/${signup.opportunity_id}`);
                      }}
                      data-testid={`view-details-button-${signup.id}`}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MySignups;